import React from 'react';

const MAP = {
  active: { fg: 'var(--success)', bg: 'var(--success-soft)', label: 'Active' },
  draft:  { fg: 'var(--text-3)',  bg: 'var(--bg-surface-2)', label: 'Draft' },
  risk:   { fg: 'var(--warning)', bg: 'var(--warning-soft)', label: 'At risk' },
};

/**
 * Status pill with leading colored dot. Three states: active / draft / risk.
 * Border uses color-mix to derive a faint outline from the foreground
 * color — this is what gives each pill a subtle hairline without us
 * having to define a third color per state.
 *
 * Pass `label` to override the default text (e.g. for custom statuses).
 */
export default function StatusPill({ status = 'active', label }) {
  const s = MAP[status] || MAP.active;
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 5,
        padding: '2px 8px',
        borderRadius: 999,
        fontSize: 12.5,
        fontWeight: 500,
        color: s.fg,
        background: s.bg,
        border: `1px solid color-mix(in oklch, ${s.fg} 18%, transparent)`,
        whiteSpace: 'nowrap',
      }}
    >
      <span
        style={{
          width: 5,
          height: 5,
          borderRadius: 99,
          background: s.fg,
          flexShrink: 0,
        }}
      />
      {label ?? s.label}
    </span>
  );
}
